module.exports = __webpack_public_path__ + "static/media/purepaper-black.cfcc0dab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brands/purepaper-black.svg
// module id = 330
// module chunks = 37